import React from 'react';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { EventPreviewEmailStatus } from 'stageclip-common';

import Button from 'components/buttons/button';
import { callApi } from 'helpers/callApi/callApi';
import { VideoReminderProps, VideoReminderState } from './SendReminderButton.type';
import styles from './SendReminderButton.module.scss';

export class SendReminderButton extends React.Component<VideoReminderProps, VideoReminderState> {
  constructor(props: VideoReminderProps) {
    super(props);

    this.state = {
      isLoading: false,
    };
  }

  handleClick = () => {
    const { sendVideoReminder, eventId } = this.props;

    callApi({
      action: () => {
        this.setState({ isLoading: true });

        return sendVideoReminder(eventId, { clipPreviewEmail: EventPreviewEmailStatus.EmailScheduled });
      },
    }).then(() => {
      this.setState({ isLoading: false });
    });
  };

  render() {
    const { clipPreviewEmailStatus } = this.props;
    const { isLoading } = this.state;
    const isEmailSent = clipPreviewEmailStatus !== EventPreviewEmailStatus.EmailNotSend;
    const buttonText = isEmailSent ? 'Notify Client again VG Video Ready' : 'Notify Client VG Video Ready';

    return (
      <Button
        onClick={this.handleClick}
        text={isLoading ? 'loading' : buttonText}
        inverseColours
        allCapitals
        icon={faEnvelope}
        className={isEmailSent ? styles.buttonDirty : styles.buttonPristine}
        disabled={isLoading}
      />
    );
  }
}
